import { useState, useEffect } from "react";

const LiveUsersIndicator = () => {
  const [count, setCount] = useState(23);

  useEffect(() => {
    // Simulate slight fluctuation
    const interval = setInterval(() => {
      setCount((prev) => {
        const delta = Math.floor(Math.random() * 5) - 2;
        return Math.max(8, Math.min(50, prev + delta));
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative z-10 flex justify-center pb-4">
      <div className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm backdrop-blur-xl bg-card/40 border border-primary/10">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-green-500" />
        </span>
        <span className="text-muted-foreground">
          <span className="font-semibold text-foreground">{count}</span> people exploring Nebula right now
        </span>
      </div>
    </div>
  );
};

export default LiveUsersIndicator;
